/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import { useEffect } from 'react';
import {
  useSelector, useDispatch,
} from 'react-redux';
import PeopleCardLarge from 'Components/common/components/PeopleCardLarge';
import { actions as guestActions } from 'Slice/GuestSlice';
import {
  selectGuestLoading,
  selectLoginResp, selectPopUpResponse, selectSearchResult,
} from 'Selector/GuestSearchSelector';
import _ from 'lodash';
import { PersonCard, PersonPopupResponse } from 'Types/PersonTypes';
import {
  backgroundColorParsing, getLocalStorageValue, isGuest, setLocalStorageValue,
} from 'Utils/UtilityFunctions';
import { Col, Row } from 'antd';
import {
  GuestLoginDataResponse,
} from 'Types/GuestSearchResultTypes';
import SectionHeading from 'Components/globalSearch/components/SectionHeading';
import LimitReached from 'Components/person/components/LimitReached';
import {
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import SearchPersonSkeletonBlock from 'Components/common/skeleton/SearchPersonSkeletonBlock';
import PeopleSvg from 'Components/layout/assets/PeopleSvg';
import NoDataFound from 'Components/common/components/NoDataFound';
import { GuestloginRequest } from 'Types/RequestBodies';
import FingerPrint from 'Components/common/components/FingerPrint';
import { PERSONALITY_INSIGHTS_ROUTE, SEARCH_ROUTE } from 'Utils/Constants';
import NavBarPrimary from '../../Components/layout/headers/NavBarPrimary';

const GuestSearch = function GuestSearch() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const guestLoginData: GuestLoginDataResponse = useSelector(selectLoginResp);
  const popUpResponse: PersonPopupResponse = useSelector(selectPopUpResponse);
  const guestLoading: boolean = useSelector(selectGuestLoading);
  const searchResult: PersonCard[] = useSelector(selectSearchResult);

  const [searchParam] = useSearchParams();
  const guestData: GuestloginRequest = {
    finger_print: FingerPrint,
    first_name: searchParam.get('first_name') || '',
    last_name: searchParam.get('last_name') || '',
    company_name: searchParam.get('company_name') || '',
    email: searchParam.get('email') || '',
    username: searchParam.get('email') || '',
  };
  useEffect(() => {
    if (_.isEmpty(searchResult)) {
      dispatch(guestActions.getGuestUserData(guestData));
    }
    // window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(guestLoginData)) {
      setLocalStorageValue('csrfToken', guestLoginData.csrfToken);
      setLocalStorageValue('username', guestLoginData.email);
      if (guestLoginData.skipOnBoarding) {
        setLocalStorageValue('skipOnBoarding', '1');
      }
    }
    if (getLocalStorageValue('active') === '1') {
      const url = `${SEARCH_ROUTE}${guestData.first_name || ''} ${guestData.last_name || ''}`;
      navigate(url);
    }
    if (searchResult.length === 1) {
      const url = `${PERSONALITY_INSIGHTS_ROUTE}${searchResult[0].personId}&personType=${searchResult[0].personType}`;
      navigate(url, { replace: true });
    }
  }, [guestLoginData]);

  return (
    <>
      <NavBarPrimary headerClassName="headers-space box-shadow no-overflow-on-header">
        <div className="left-side-wrap">
          {!guestLoading && (
            <>
              <PeopleSvg />
              <h1 className={classNames('heading', { guestHeading: isGuest() })}>Select a person</h1>
            </>
          )}
        </div>
      </NavBarPrimary>
      <div className="container">
        {guestLoading ? (
          <SearchPersonSkeletonBlock />
        )
          : popUpResponse?.showPlanPopup === 1
            ? (
              <LimitReached popupResponse={popUpResponse} />
            ) : (
              <>
                {searchResult.length > 0 ? <SectionHeading>Profile found</SectionHeading> : null}
                <Row className={classNames('Grid-width-row col-six-fix-md')} gutter={[24, 24]}>
                  {searchResult.length > 0 && searchResult.map((person: PersonCard) => (
                    <Col span={4} className="gutter-row">
                      <PeopleCardLarge
                        noFollow
                        personName={person.personName}
                        logo={person.personImage}
                        persona={person.archeType.color}
                        tag={person.personDesignation}
                        personaType={person.archeType.name}
                        hidePersonality={false}
                        personAddedFlag={person.personAdded}
                        personId={person.personId}
                        personality={person.personType}
                        wrapperColor={backgroundColorParsing(person.personalityTypes)}
                        personalityTypesColors={person.personalityTypes}
                        isBtnAdd
                        company={person.companyName}
                      />
                    </Col>
                  ))}
                </Row>
              </>
            )}
        {searchResult && searchResult.length === 0 && popUpResponse.showPlanPopup < 1 ? <NoDataFound title="No Record Found" /> : null}
      </div>
    </>
  );
};

export default GuestSearch;
